<template>
  <div style="overflow: hidden">
    <div
      :class="{ row: !props.hiddenLeftContainer }"
      class="col-12 q-gutter-xs"
    >
      <div class="col-5">
        <span
          class="row col-12 q-mb-sm text-brand-1 text-weight-bold"
          style="font-size: 16px"
          >{{
            tipoMetodo == "cadastro"
              ? "Utilize a câmera para fazer o cadastro:"
              : "Utilize a câmera para autenticar a retirada:"
          }}
        </span>
        <div
          style="
            border: 1px solid #d9d9d9;
            width: 100%;
            height: 350px;
            border-radius: 8px;
            position: relative;
          "
        >
          <div style="z-index: 3" class="container-elipse">
            <div
              v-if="camera"
              style="
                border: 8px dashed #304f78;
                height: 250px;
                width: 190px;
                border-radius: 100%;
              "
              class="elipse"
            ></div>
            <div
              v-if="!camera"
              style="cursor: pointer; font-size: 28px"
              class="text-brand-1 text-weight-bold"
              @click="camera ? pausarVideo() : getUserImage()"
            >
              Clique aqui para ativar a camêra
            </div>
            <div
              v-if="props.tipoMetodo == 'verificacao' && verificacao"
              style="color: #85d546; font-size: 25px"
              class="text-weight-bold"
            >
              <span class="row justify-center">Usuário</span>
              <div class="row justify-center">
                <q-icon
                  size="130px"
                  class="row q-my-md"
                  name="sym_o_verified"
                />
              </div>
              <span class="row justify-center">Verificado</span>
            </div>
          </div>
          <div v-if="!faceVerificacao" class="container-btn">
            <q-btn
              v-if="camera"
              label="Capturar"
              no-caps
              stack
              dense
              style="
                color: #304f78;
                border-radius: 8px;
                background-color: white;
              "
              icon="sym_o_add_a_photo"
              @click="screenShot"
            />
          </div>
          <video class="faceCapture" autoplay></video>
          <canvas
            v-show="false"
            style="height: 100%; width: 50%; position: absolute"
            class="canvasFace"
          ></canvas>
          <div v-if="faceVerificacao" class="container-btn-imagem-verificacao">
            <q-btn
              no-caps
              stack
              dense
              style="
                color: #304f78;
                border-radius: 8px;
                background-color: white;
              "
              icon="sym_o_replay"
              @click="tirarNovamente()"
            />
          </div>
          <div
            v-show="faceVerificacao && props.verificacao == false"
            style="
              height: 100%;
              width: 100%;
              z-index: 8;
              border-radius: 8px;
              position: absolute;
              top: 0px;
              left: 0px;
              background-color: black;
            "
          >
            <img
              style="
                height: 100%;
                width: 100%;
                z-index: 8;
                border-radius: 8px;
                position: absolute;
                top: 0px;
                left: 0px;
                right: 0px;
                object-fit: contain;
              "
              class="canvasFaceVerificacao"
            />
          </div>
        </div>
        <div v-if="camera" class="row col-12 q-my-md justify-end q-gutter-sm">
          <q-btn
            v-if="props.tipoMetodo == 'verificacao'"
            label="Finalizar Retirada"
            no-caps
            :loading="verifyLoading"
            :disable="faceList.length == 0 || verifyLoading"
            icon="sym_o_fit_screen"
            style="color: white; border-radius: 8px; background-color: #304f78"
            @click="props.naoVerificar ? enviarFaceImagem() : verificarFace()"
          />
          <q-btn
            label="Cancelar"
            outline
            no-caps
            icon="close"
            style="color: #304f78; border-radius: 8px"
            @click="pausarVideo"
          />
          <q-btn
            v-if="props.tipoMetodo == 'cadastro'"
            label="Cadastrar"
            no-caps
            :loading="verifyLoading"
            :disable="faceList.length == 0 || verifyLoading"
            icon="save"
            style="color: white; border-radius: 8px; background-color: #304f78"
            @click="faceList?.length === 1 ? enviarFace() : enviarFacesLote()"
          />
        </div>
      </div>
      <q-separator
        v-if="props.tipoMetodo == 'cadastro'"
        vertical
        inset
        size="2px"
        class="q-mx-md"
      />
      <div
        v-if="faceList.length > 0 && props.tipoMetodo == 'cadastro'"
        class="col-5"
      >
        <span
          class="row col-12 q-mb-sm text-brand-1 text-weight-bold"
          style="font-size: 16px"
          >Fotos capturadas:</span
        >
        <div class="">
          <q-carousel
            style="height: 350px; border-radius: 8px"
            swipeable
            height="100px"
            animated
            arrows
            v-model="slide"
            thumbnails
            infinite
          >
            <q-carousel-slide
              v-for="(img, index) in faceList"
              :key="index"
              :name="img.name"
              :img-src="img.image"
            />
            <template v-slot:control>
              <q-carousel-control
                position="top-right"
                :offset="[18, 18]"
                class="text-white rounded-borders"
              >
                <q-btn
                  icon="sym_o_delete"
                  flat
                  color="red"
                  round
                  @click="excluirImg"
                />
              </q-carousel-control>
            </template>
          </q-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  onMounted,
  defineProps,
  watch,
  defineEmits,
  onUnmounted,
} from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

const store = useStore();
const quasar = useQuasar();
const verifyLoading = ref(false);
const devicesList = ref([]);
const sendSucess = ref(false);
const faceList = ref([]);
const slide = ref(1);
const camera = ref(false);
const stream = ref(null);
const contrains = ref({
  video: {
    width: {
      min: 1280,
      ideal: 1920,
      max: 1920,
    },
    height: {
      min: 720,
      ideal: 1080,
      max: 1080,
    },
  },
});
const props = defineProps({
  idUsuario: {},
  tipoMetodo: {},
  naoVerificar: {
    type: Boolean,
    default: false,
  },
  hiddenLeftContainer: {
    type: Boolean,
    default: false,
  },
  verificacao: {
    type: Boolean,
    default: false,
  },
  isFacial: {
    type: Boolean,
  },
});

const emits = defineEmits(["resultadoVerificacao", "atualizarBiometrias"]);
const faceVerificacao = ref(false);
//const usersList = ref([]);
const faceVerificada = ref(false);

const getUserImage = async () => {
  const video = document.querySelector(".faceCapture");
  if ("mediaDevices" in navigator && "getUserMedia" in navigator.mediaDevices) {
    await navigator.mediaDevices
      .getUserMedia({
        ...contrains.value,
      })
      .then((value) => {
        stream.value = value;
        video.srcObject = value;
        video.play();
        camera.value = true;
      })
      .catch((error) => {
        if (error.message === "Permission denied") {
          quasar.notify({
            message:
              "A permissão do navegador para uso da camêra não está habilitada.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      });
  }
};

const pausarVideo = async () => {
  if (stream.value) {
    stream.value.getTracks().forEach(function (track) {
      track.stop();
    });
  }

  const video = document.querySelector(".faceCapture");
  if (video) {
    video.srcObject = null; // Certifique-se de limpar a referência do stream
  }

  camera.value = false;
  faceList.value = [];
  faceVerificacao.value = false;
};

const screenShot = async () => {
  const canvas = document.querySelector(".canvasFace");
  const video = document.querySelector(".faceCapture");
  const containerImgVerificacao = document.querySelector(
    ".canvasFaceVerificacao"
  );

  const targetWidth = 960;
  const targetHeight = 1280;

  const sourceWidth = video.videoWidth;
  const sourceHeight = video.videoHeight;
  const sourceAspect = sourceWidth / sourceHeight;
  const targetAspect = targetWidth / targetHeight;

  let drawWidth, drawHeight, startX, startY;

  if (sourceAspect > targetAspect) {
    drawHeight = sourceHeight;
    drawWidth = sourceHeight * targetAspect;
    startX = (sourceWidth - drawWidth) / 2;
    startY = 0;
  } else {
    drawWidth = sourceWidth;
    drawHeight = sourceWidth / targetAspect;
    startX = 0;
    startY = (sourceHeight - drawHeight) / 2;
  }

  canvas.width = targetWidth;
  canvas.height = targetHeight;
  const ctx = canvas.getContext("2d");

  ctx.drawImage(
    video,
    startX,
    startY,
    drawWidth,
    drawHeight,
    0,
    0,
    targetWidth,
    targetHeight
  );

  if (props.tipoMetodo == "cadastro") {
    faceList.value.push({
      image: canvas.toDataURL("image/jpeg", 0.9),
      name: Math.random(),
    });
    return;
  }
  faceList.value[0] = {
    image: canvas.toDataURL("image/jpeg", 0.9),
    name: Math.random(),
  };
  faceVerificacao.value = true;
  containerImgVerificacao.src = faceList.value[0].image;
  slide.value = faceList.value[0].name;
};

const getDevices = async () => {
  const devices = await navigator.mediaDevices.enumerateDevices();

  devicesList.value = devices.filter((value) => {
    if (value.label != "") {
      return { id: value.deviceId, label: value.label };
    }
  });
};

const excluirImg = () => {
  let index = faceList.value.findIndex((value) => value.name === slide.value);

  faceList.value.splice(index, 1);

  if (faceList.value.length > 0) {
    slide.value = faceList.value[0].name;
  }
};

onMounted(getDevices);

const enviarFace = async () => {
  verifyLoading.value = true;
  try {
    const base64Image =
      faceList.value[0].image.split(",")[1] ||
      faceList.value[0].image.slice(23);

    await store.dispatch("user/cadastrarFacial", {
      usuarioId: props.idUsuario,
      biometria: faceList.value[0].image,
    });

    quasar.notify({
      message: "Rosto cadastrado com sucesso",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });

    emits("atualizarBiometrias", {
      imagem: faceList.value[0].image,
      base64: base64Image,
    });

    sendSucess.value = true;
    faceList.value = [];
    verifyLoading.value = false;
    pausarVideo();
  } catch (error) {
    verifyLoading.value = false;
    quasar.notify({
      message: "Erro a o cadastrar rosto",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const enviarFacesLote = async () => {
  verifyLoading.value = true;
  const fotosEnviadas = [];

  try {
    for (const face of faceList.value) {
      const base64Image = face.image.split(",")[1] || face.image.slice(23);

      await store.dispatch("user/cadastrarFacial", {
        usuarioId: props.idUsuario,
        biometria: face.image,
      });

      fotosEnviadas.push({
        imagem: face.image,
        base64: base64Image,
      });
    }

    quasar.notify({
      message: `${fotosEnviadas.length} ${
        fotosEnviadas.length === 1 ? "foto cadastrada" : "fotos cadastradas"
      } com sucesso`,
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });

    emits("atualizarBiometrias", {
      quantidade: fotosEnviadas.length,
      todasFotos: fotosEnviadas,
    });

    verifyLoading.value = false;
    sendSucess.value = true;
    faceList.value = [];
    pausarVideo();
  } catch (error) {
    verifyLoading.value = false;
    quasar.notify({
      message: "Erro ao cadastrar rosto",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const verificarFace = async () => {
  verifyLoading.value = true;
  try {
    const clienteId = store.state.autenticacao.cliente[0];
    const idFace = `${clienteId}${props.idUsuario}`;

    const base64Image =
      faceList.value[0].image.split(",")[1] ||
      faceList.value[0].image.slice(23);

    await store.dispatch("facialStore/verificarFacial", {
      id: idFace,
      base64_image: base64Image,
      livesCheck: true,
    });

    quasar.notify({
      message: "Rosto identificado com sucesso",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    faceVerificada.value = true;
    verifyLoading.value = false;
    emits("resultadoVerificacao", {
      resultadoVerificacao: faceVerificada.value,
      imagemVerificacao: faceList.value[0].image,
    });
  } catch (error) {
    console.error("Erro na verificação facial:", error);
    verifyLoading.value = false;
    faceVerificada.value = false;
    emits("resultadoVerificacao", {
      resultadoVerificacao: faceVerificada.value,
      imagemVerificacao: null,
    });
    quasar.notify({
      message: "Rosto não encontrado",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

onMounted(() => {
  getUserImage();
});

const tirarNovamente = () => {
  faceVerificacao.value = false;
  faceList.value = [];
};

const enviarFaceImagem = () => {
  const base64Image =
    faceList.value[0].image.split(",")[1] || faceList.value[0].image.slice(23);

  emits("resultadoVerificacao", {
    resultadoVerificacao: false,
    imagemVerificacao: base64Image,
  });
};

watch(
  () => faceList.value?.length,
  (atual, antigo) => {
    if (faceList.value.length == 0) {
      return;
    }
    if (props.tipoMetodo == "cadastro") {
      if (antigo > 0 && atual > 0) {
        return;
      }
      slide.value = faceList.value[0].name;
      return;
    }
    slide.value = faceList.value[0].name;
  }
);

onUnmounted(() => {
  pausarVideo();
  faceList.value = [];
});
</script>

<style scoped>
/* .print-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
} */

video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  transform: scaleX(-1); /* Espelha horizontalmente */
}

.face-container-bottom {
  display: grid;
  margin-top: 100px;
  gap: 19px;
  justify-content: center;
}

.face-container-bottom img {
  width: 400px;
  height: 400px;
  object-fit: cover;
}

.grid-template-columns {
  grid-template-columns: 400px 400px 400px;
}
.container-elipse {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
}

.container-btn {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 10px;
  bottom: 0px;
  right: 0px;
  position: absolute;
  z-index: 9;
}
.container-btn-ligar {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 10px;
  top: 0px;
  left: 0px;
  position: absolute;
  z-index: 10;
}
.container-btn-imagem-verificacao {
  bottom: 0px;
  right: 0px;
  padding: 10px;
  position: absolute;
  z-index: 11 !important;
}
.q-carousel__slide {
  background-color: black;
  background-size: contain;
  background-repeat: no-repeat;
}
</style>
